import { graphqlFetch } from "@/utils/graphqlFetch";
import { useQuery } from "@tanstack/react-query";
import { RegionOutput } from "../gql/graphql";
import { GET_REGIONS } from "../queries/region";

export const useGetRegions = () => {
  return useQuery<RegionOutput[], Error>({
    queryKey: ['getRegions'],
    queryFn: async () => {
      const data = await graphqlFetch<{ getRegions: RegionOutput[] }, null>(GET_REGIONS);
      return data.getRegions;
    },
  });
};
